
import React from "react";
import KnowledgeSearch from "./KnowledgeSearch";
import KnowledgeCollectionsList from "./KnowledgeCollectionsList";
import KnowledgeArticleView from "./KnowledgeArticleView";
import { KnowledgeArticle, KnowledgeCollection } from "./types";

interface KnowledgeBaseEmbeddedProps {
  collections: KnowledgeCollection[];
  selectedArticle: KnowledgeArticle | null;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearch: () => void;
  handleArticleSelection: (article: KnowledgeArticle) => void;
  setSelectedArticle: (article: KnowledgeArticle | null) => void;
}

const KnowledgeBaseEmbedded = ({
  collections,
  selectedArticle,
  searchQuery,
  setSearchQuery,
  handleSearch,
  handleArticleSelection,
  setSelectedArticle,
}: KnowledgeBaseEmbeddedProps) => {
  return (
    <div className="space-y-4">
      <div className="mb-4">
        <KnowledgeSearch
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearch={handleSearch}
          isEmbedded={true}
        />
      </div>

      {selectedArticle ? (
        <KnowledgeArticleView
          article={selectedArticle}
          onBack={() => setSelectedArticle(null)}
          isEmbedded={true}
        />
      ) : (
        <KnowledgeCollectionsList
          collections={collections}
          onArticleSelect={handleArticleSelection}
          isEmbedded={true}
        />
      )}
    </div>
  );
};

export default KnowledgeBaseEmbedded;
